import React from 'react'
import { isEmpty, trim, compose, defaultTo, prop, pathOr } from 'ramda'
import { useFetch, useForm } from '../../../../../../../../hooks'
import Button from '../../../../../../../../components/inputs/Button'
import Buttons from '../../../../../../../../modules/Buttons'
import { StyledForm, StyledSteps, StyledStepsHeader, StyledStepsItem, StyledStepName, StyledStepDesc, StyledFormSelectWrapper, StyledStepImage } from './styled'
import FromSelect from '../../../../../../../../components/inputs/FromSelect';
import { toast } from 'react-toastify'

const FormAddBiosensor = ({ cowid, biosensor, endpoint, onClickCancel, refetchCow }) => {

    const { response } = useFetch({
        url: `/${endpoint}`,
        method: 'GET'
    })

    const { fetching, doFetch } = useFetch({
        url: `/rpc/set_${biosensor.name}`,
        method: 'POST'
    })

    const validate = values => {
        const isEmptyNumber = compose(isEmpty, trim, defaultTo(''), prop('serial'))
        if (isEmptyNumber(values)) {
            return {
                serial: ''
            }
        }
        return {}
    }

    const addBiosensor = async values => {
        const response = await doFetch({
            data: {
                serial_: values.serial,
                cowid
            }
        })

        const isError = pathOr(false, ['error'], response);
        const message = pathOr(null, ['msg'], response);
        if (isError) {
            message && toast.error(message);
        } else {
            message && toast.success(message);
            onClickCancel()
            await refetchCow({ loader: true })
        }
    }

    const { values, errors, handleChange, handleSubmit } = useForm({
        callback: addBiosensor,
        validate: validate
    })

    return (
        !isEmpty(response.data) &&
        <StyledForm onSubmit={handleSubmit}>
            <StyledSteps>
                <StyledStepsHeader>
                    {
                        response.data[0].title
                    }
                </StyledStepsHeader>
                <StyledStepsItem>
                    <StyledStepName>
                        {`1. ${response.data[0].step1.title}`}
                    </StyledStepName>
                    <StyledStepDesc>
                        {response.data[0]['step1'].info}
                    </StyledStepDesc>
                    {biosensor && response.data[0]['step1'].icon && (
                        <StyledStepImage>
                            <img src={`/${response.data[0]['step1'].icon}`} alt="biosensor instruction" />
                        </StyledStepImage>
                    )}
                </StyledStepsItem>
                <StyledStepsItem>
                    <StyledStepName>
                        {`2. ${response.data[0]['step2'].title}`}
                    </StyledStepName>
                    <StyledStepDesc>
                        {response.data[0]['step2'].info}
                    </StyledStepDesc>
                    <StyledFormSelectWrapper>
                        <FromSelect
                            placeholder={response.data[0]['step2'].placeholder}
                            name='serial'
                            onChange={handleChange}
                            value={values.serial}
                            error={errors.serial}
                            options={response.data[0]['step2']['data'].map(option => ({ value: option, label: option }))}
                            green
                            noMargin
                        />
                    </StyledFormSelectWrapper>
                    <Buttons>
                        <Button
                            type='button'
                            onClick={onClickCancel}
                            width='50%'
                        >
                            {response.data[0]['step2'].buttons.cancel}
                        </Button>
                        <Button
                            type='submit'
                            green
                            width='50%'
                            disabled={fetching}
                        >
                            {response.data[0]['step2'].buttons.save}
                        </Button>
                    </Buttons>
                </StyledStepsItem>
            </StyledSteps>
        </StyledForm>
    )
}

export default FormAddBiosensor
